/** マクニカ管理者向けテーブルカラム */
export const SYSTEM_ADMIN_TABLE_COLUMN_LIST: string[] = [
  'checkbox',
  'operationType',
  'userId',
  'date',
] as const;

/** 顧客管理者向けテーブルカラム */
export const ADMIN_TABLE_COLUMN_LIST: string[] = [
  'checkbox',
  'operationType',
  'userId',
  'date',
] as const;

/** 顧客ユーザ向けテーブルカラム */
export const GENERAL_TABLE_COLUMN_LIST: string[] = [
  'checkbox',
  'operationType',
  'userId',
  'date',
] as const;
